module.exports = __webpack_public_path__ + "static/media/ICBT 3c2.8d359db8.jpg";